import $ from 'jquery';

class Slider {
    constructor() {
        this.slider = $("#slider");
        this.items = $("#items");
        this.one = $("#one");
        this.two = $("#two");
        this.three = $("#three");
        this.posX1 = 0;
        this.posX2 = 0;
        this.posInitial;
        this.posFinal;
        this.threshold = 1;
        this.slides = this.items.find(".slide");
        this.slidesLength = this.slides.length;
        this.slideSize = this.slides.eq(0).outerWidth();
        this.firstSlide = this.slides.eq(0);
        this.secondSlide = this.slides.eq(1);
        this.lastSlide = this.slides.eq(2);
        this.cloneFirst = this.firstSlide.clone();
        this.cloneSecond = this.secondSlide.clone();
        this.cloneSecond_2 = this.secondSlide.clone();
        this.cloneLast = this.lastSlide.clone();
        this.index = 0;
        this.allowShift = true;
        // Clone first, second(hard coded), last slide
        this.items.append(this.cloneFirst);
        this.items.append(this.cloneSecond_2);
        this.cloneLast.insertBefore(this.firstSlide);
        this.cloneSecond.insertBefore(this.cloneLast);
        this.slider.addClass('loaded');
        this.window = $(window);

        if(this.slider) {
            this.events();
        }
    }

    // events
    events() {
        this.window.on('resize', this.setSize.bind(this));

        // Mouse and Touch events
        this.items.on('mousedown', this.dragStart.bind(this));

        // Touch events
        this.items.on('touchstart', this.dragStart.bind(this));
        this.items.on('touchend', this.dragEnd.bind(this));
        this.items.on('touchmove', this.dragAction.bind(this));

        // Click events
        this.one.on('click', () => {
            if (this.index == 1) {
                this.shiftSlide(-1);
            } else if (this.index == 2) {
                this.shiftSlide(1);
            }
        });
        this.two.on('click', () => {
            if (this.index == 2) {
                this.shiftSlide(-1);
            } else if (this.index == 0) {
                this.shiftSlide(1);
            }
        });
        this.three.on('click', () => {
            if (this.index == 0) {
                this.shiftSlide(-1);
            } else if (this.index == 1) {
                this.shiftSlide(1);
            }
        });

        // Transition events
        this.items.on('transitionend', this.checkIndex.bind(this));
    }

    // methods
    setSize(e) {
        if (this.index == 1) {
            this.shiftSlide(-1);
        } else if (this.index == 2) {
            this.shiftSlide(1);
        }
        this.slidesLength = this.slides.length;
        this.slideSize = this.slides.eq(0).outerWidth();
    }

    dragStart(e) {
        e = e || window.event;
        e.preventDefault();
        this.posInitial = this.items.position().left;

        if (e.type == 'touchstart') {
            this.posX1 = e.touches[0].clientX;
        } else {
            this.posX1 = e.clientX;
            document.onmouseup = this.dragEnd.bind(this);
            document.onmousemove = this.dragAction.bind(this);
        }
    }

    dragAction(e) {
        e = e || window.event;
        if (e.type == 'touchmove') {
            this.posX2 = this.posX1 - e.touches[0].clientX;
            this.posX1 = e.touches[0].clientX;
        } else {
            this.posX2 = this.posX1 - e.clientX;
            this.posX1 = e.clientX;
        }
        this.items.css('left', this.items.position().left - this.posX2);
    }

    dragEnd(e) {
        this.posFinal = this.items.position().left;
        if (this.posFinal - this.posInitial < -this.threshold) {
            this.shiftSlide(1, 'drag');
        } else if (this.posFinal - this.posInitial > this.threshold) {
            this.shiftSlide(-1, 'drag');
        } else {
            this.items.css('left', (this.posInitial));
        }

        document.onmouseup = null;
        document.onmousemove = null;
    }

    shiftSlide(dir, action) {
        this.items.addClass('shifting');

        if (this.allowShift) {
            if (!action) { this.posInitial = this.items.position().left; }

            if (dir == 1) {
                this.items.css('left', (this.posInitial - this.slideSize));
                switch (this.index) {
                    case 0:
                        this.firstSlide.removeClass('active');
                        this.cloneFirst.removeClass('active');
                        this.one.removeClass('active');
                        this.secondSlide.addClass('active');
                        this.two.addClass('active');
                        break;
                    case 1:
                        this.secondSlide.removeClass('active');
                        this.two.removeClass('active');
                        this.lastSlide.addClass('active');
                        this.three.addClass('active');
                        break;
                    case 2:
                        this.cloneLast.removeClass('active');
                        this.lastSlide.removeClass('active');
                        this.three.removeClass('active');
                        this.cloneFirst.addClass('active');
                        this.firstSlide.addClass('active');
                        this.one.addClass('active');
                        break;
                }
                this.index++;
            } else if (dir == -1) {
                this.items.css('left', (this.posInitial + this.slideSize));
                switch (this.index) {
                    case 0:
                        this.firstSlide.removeClass('active');
                        this.cloneFirst.removeClass('active');
                        this.one.removeClass('active');
                        this.cloneLast.addClass('active');
                        this.lastSlide.addClass('active');
                        this.three.addClass('active');
                        break;
                    case 1:
                        this.secondSlide.removeClass('active');
                        this.two.removeClass('active');
                        this.firstSlide.addClass('active');
                        this.one.addClass('active');
                        break;
                    case 2:
                        this.lastSlide.removeClass('active');
                        this.cloneLast.removeClass('active');
                        this.three.removeClass('active');
                        this.secondSlide.addClass('active');
                        this.two.addClass('active');
                        break;
                }
                this.index--;
            }
        };

        this.allowShift = false;
    }

    checkIndex() {
        this.items.removeClass('shifting');

        if (this.index == -1) {
            this.items.css('left', -(this.slidesLength * this.slideSize));
            this.index = this.slidesLength - 1;
        }

        if (this.index == this.slidesLength) {
            this.items.css('left', -(1 * this.slideSize));
            this.index = 0;
        }

        this.allowShift = true;
    }
}

export default Slider;